export const OS_PERMISSIONS = {
  kpis: {
    read: 'os.kpis.read',
    create: 'os.kpis.create',
    modify: 'os.kpis.modify',
    delete: 'os.kpis.delete',
  },
  rocks: {
    read: 'os.rocks.read',
    create: 'os.rocks.create',
    modify: 'os.rocks.modify',
    delete: 'os.rocks.delete',
  },
  headlines: {
    read: 'os.headlines.read',
    create: 'os.headlines.create',
    modify: 'os.headlines.modify',
    delete: 'os.headlines.delete',
  },
  todos: {
    read: 'os.todos.read',
    create: 'os.todos.create',
    modify: 'os.todos.modify',
    delete: 'os.todos.delete',
  },
  meetings: {
    read: 'os.meetings.read',
    create: 'os.meetings.create',
    modify: 'os.meetings.modify',
    delete: 'os.meetings.delete',
  },
  vto: {
    read: 'os.vto.read',
  },
} as const;
